import { useState } from "react";
import useAuthStore from "./states/authStore";
import { usePageTransition } from "@iq/models";

const AUTH_API_BASE_URL = "http://localhost:8086";

const PM_FILTER_SESSION_KEYS = [
  "pm_kanban_selected_project_id",
  "pm_kanban_selected_people_ids",
];

function clearPmFilterSessionState() {
  try {
    PM_FILTER_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
  } catch (err) {
    console.error("Failed clearing PM filter session state", err);
  }
}

function Login() {
  const setProfile = useAuthStore((state) => state.setProfile);
  const { runTransition } = usePageTransition();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${AUTH_API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          email: email.trim(),
          password,
        }),
      });

      let payload = {};
      try {
        payload = await response.json();
      } catch {
        payload = {};
      }

      if (!response.ok) {
        throw new Error(payload.error || "Login failed");
      }

      if (!payload.user) {
        throw new Error("Login response missing user");
      }

      clearPmFilterSessionState();
      setProfile(payload.user);

      await runTransition({
        to: "/",
        replace: true,
      });
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="login-wrap">
      <div className="login-card">
        <h1 className="login-title">Login</h1>
        <p className="login-subtitle">Enter your email and password to continue.</p>
        <form onSubmit={onSubmit} className="login-form">
          <input
            className="login-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            autoComplete="email"
          />
          <input
            className="login-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoComplete="current-password"
          />
          <button className="login-button" disabled={loading || !email.trim() || !password}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        {error ? <p className="login-error">{error}</p> : null}
      </div>
    </section>
  );
}

export default Login;